module.exports = __webpack_public_path__ + "img/quote2.e15fe310.jpg";